import { connect } from 'react-redux';
import HeaderText from 'header/components/title';
import { MP_CLICKED_GET_STARTED_EVENT_NAME } from 'common/tracking';

export const DEFAULT_HEADER_TEXT = 'Thousands of projects just like yours.';
export const MEET_CREATIVES = 'Meet the world\'s largest creative team.';
export const MEET_COLLEAGUES = 'Meet your fellow creatives.';

export function mapStateToProps({ header, user }) {
  const userType = user.profile_data ? user.profile_data.user_type : 'anonymous';
  const creativesHeader = userType === 'creative' ? MEET_COLLEAGUES : MEET_CREATIVES;
  const showStartProject = user.logged_in === false || userType === 'client';
  const cta = showStartProject ? { url: '/start-a-project/', label: 'Get started' } : null;

  return {
    title: header.content === 'explore_creatives' ? creativesHeader : DEFAULT_HEADER_TEXT,
    isTitleMain: header.content !== 'explore_creatives',
    cta,
    buttonEventTracking:{
      eventName: MP_CLICKED_GET_STARTED_EVENT_NAME,
      eventData: {
        pageName: 'explore_creatives' ? 'Explore creatives' : 'Explore projects',
        pageArea: "Header",
      }
    }
  };
}

export default connect(mapStateToProps)(HeaderText);



// WEBPACK FOOTER //
// ./explore/containers/header_title.jsx